import { Routes } from '@angular/router';
import { LoginComponent } from 'src/app/layout/auth-layout/login/login.component';
import { RegisterComponent } from 'src/app/layout/auth-layout/register/register.component';
import { ForgotPasswordComponent } from 'src/app/layout/auth-layout/forgot-password/forgot-password.component';
import { AppRoutes } from '../models/routes.model';

export const authRoutes: Routes = [
  {
    path: AppRoutes.AUTH_LOGIN,
    component: LoginComponent,
  },
  {
    path: AppRoutes.AUTH_REGISTER,
    component: RegisterComponent,
  },
  {
    path: AppRoutes.AUTH_FORGOT_PASSWORD,
    component: ForgotPasswordComponent,
  },
];
